import { WsEventListener } from "@fidget/common/services/eventsListener";
import { ITagsStore } from "./TagsStore";

export class TagsStoreEventListener implements WsEventListener {
  constructor(private _tagStoreFinder: () => ITagsStore, public name: string) {}

  get tagsStore(): ITagsStore {
    return this._tagStoreFinder();
  }

  connected() {
    this.tagsStore.loadTags();
  }
}
